import React from "react";
import {I, T} from "services/lang/LanguageService";

const DevSandbox = () => {
  return (
      <div>
          <li>{T("greeting", {name: "Vardenis Pavardenis"})}</li>
          <li>{T("mango.ango", {name: "Vardenis Pavardenis"})}</li>
          <li>{T("test-key")}</li>
          <li>{T("side-menu.home")}</li>

          <li>{I("Hello {greeting} and {side-menu.home} and {a.test-key}")}</li>
      </div>
  );
};

export default DevSandbox;